import { render } from "./ClientClientesEditar.vue?vue&type=template&id=26dff674&scoped=true"
import script from "./ClientClientesEditar.vue?vue&type=script&lang=js"
export * from "./ClientClientesEditar.vue?vue&type=script&lang=js"

import "./ClientClientesEditar.vue?vue&type=style&index=0&id=26dff674&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26dff674"]])

export default __exports__